import { useDataContext } from '#/hooks';
import PageController from '#/pages/PageController';

import { useUnauthenticatedHomePage } from './useUnauthenticatedHomePage';

export const UnauthenticatedHomePage = () => {
  const { pageId: unauthenticatedHomePageId } = useUnauthenticatedHomePage();
  const { getGeneralContext } = useDataContext();

  const defaultContext = getGeneralContext();

  return (
    <PageController
      defaultContext={defaultContext}
      pageId={unauthenticatedHomePageId}
    />
  );
};
